import axios from 'axios';
import qs from 'qs';

import { Message } from 'element-ui';

// if (process.env.NODE_ENV == 'development') {
//     axios.defaults.baseURL = 'https://www.baidu.com';}
// else if (process.env.NODE_ENV == 'debug') {
//     axios.defaults.baseURL = 'https://www.ceshi.com';
// }
// else if (process.env.NODE_ENV == 'production') {
//     axios.defaults.baseURL = 'https://www.production.com';
// }

// 1,创建实例
const service = axios.create({
  // baseURL:'http://gpw.dev-o2.myoas.com/artifact/web',
  baseURL: '',
  // baseURL:'http://gpw.dev-o2.myoas.com/artifact/web',
  timeout: 10 * 1000,
  withCredentials: false,
});

// 2.请求拦截器
service.interceptors.request.use(
  (config) => {
    config.data = qs.stringify(config.data);
    // config.headers = {
    //   // 'Content-Type':'application/x-www-form-urlencoded format'
    //   "Content-Type": "multipart/form-data",
    //   // 'Content-Type':'application/json'
    // };

    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    const token = '';
    // const token =
    //   'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOiJBVVRIX0lUX1NTTyIsInN1YiI6Ilc5MDEwMzM5IiwiaXNzIjoiVEdULTExNDgteXBtMTMwRmNuYkMzYW1yWUNhZkZJVGRidktjdG9Yekh3b2U5R2ZHMkh5ZGtqbktGejQtU0lBTSIsIm5hbWUiOiJTSUFNVEdUIiwidHlwZSI6IlRHVCIsImlhdCI6MTYyMTQ5OTYzNX0.uG7tvDGWx92LcHvfqDNAv_C-pZK_tFQTn37CPI0Ablc' // 待做
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
// 3 .响应拦截器
service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    Message.error(error.message);
    return Promise.reject(error.response);
  },
);

const request = (method, url, opts = {}) => {
  console.log(opts, 'opts');
  return (data) => {
    let httpDefaultoptions = {
      method,
      url,
      params: data,
      data,
      // data: qs.stringify(data),
    };
    if (method === 'get') {
      delete httpDefaultoptions.data;
    } else {
      delete httpDefaultoptions.params;
    }
    console.log('httpDefaultoptions', httpDefaultoptions);
    return new Promise((resolve, reject) => {
      service(httpDefaultoptions)
        .then((res) => {
          console.log(res, '00res');
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    }); // end promise
  };
};

export default request;
